module.exports = __webpack_public_path__ + "img/AssociationLineEndIcon5.b858d447.svg";